import React, { Component } from 'react'
import { Link } from 'gatsby'
import get from 'lodash/get'
import { buildURL } from '../../utils/url'
import EventTracker from './../../helpers/EventTracker'
import moment from 'moment'

export default class BlogLinkWidget extends Component {
    render() {
        const { className } = this.props
        const { title, story, summary, heroImage, externalHyperlink, internalHyperlink, updatedAt } = this.props.data
        const backgroundImageUrl = get(heroImage, 'file.url', null)
        const backgroundImageTitle = get(heroImage, 'title', null)
        return (
            <div className={`link-card  story-block ${className ? className : ''}`}>
                <div className="link-heading">
                    <img src={backgroundImageUrl || '/placeholder.svg'} alt={backgroundImageTitle} />
                </div>
                <div className="link-info">
                    <div className="link-body">
                        <span className="date">Starship Hospital - {moment(updatedAt).format('D MMMM YYYY')}</span>
                        <h4>
                            <Link to={story ? buildURL(story) : internalHyperlink ? buildURL(internalHyperlink) : externalHyperlink} onClick={() => EventTracker.customEvent(EventTracker.EVENT_CATEGORIES.STORY_BLOCK, EventTracker.EVENT_TYPES.CLICK, 'TITLE')}>
                                {' '}
                                {title}
                            </Link>
                        </h4>
                        <p>{get(summary, 'summary')}</p>
                    </div>
                    <div className="link-links">{this.seeMore()}</div>
                </div>
            </div>
        )
    }

    seeMore = () => {
        const { goToPage } = this.props.data
        const internalUrl = buildURL(this.props.data)

        return (
            <Link className="buttonLink read-more-link" to={internalUrl} onClick={() => EventTracker.customEvent(EventTracker.EVENT_CATEGORIES.STORY_BLOCK, EventTracker.EVENT_TYPES.CLICK, 'SEE_MORE_BUTTON')}>
                <span className="read-more-link-text">{goToPage ? goToPage : 'Read More'}</span>
                <i className="fa fa-arrow-right icon" />
            </Link>
        )
    }
}
